import React, { useEffect, useState } from "react";
import { Trash2, Eye, SquarePen, Plus, Search, ListRestart } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import Pagination from "../utils/pagination/Pagination";
import { toast } from "react-toastify";
import ShadeSearchDrawer from "./ShadeSearchDrawer";
import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi";
import { countShade, deleteShade } from "../../../redux/api/admin/shadeApi";
import { deleteShadeAction, setFilteredStatus } from "../../../redux/reduxSlice/admin/ShadesSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryList } from "../../../redux/reduxApi/admin/CategoryReduxApi";
import { usePermission } from "../../../../context/PermissionContext";
import { formatDateTime, getFullName } from "../../../../utils/commonFunctions";

function ShadesList() {
  const { canAdd, canEdit, canViewAll, canDelete } = usePermission();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [recordCount, setRecordCount] = useState();

  const [deleteShadeId, setDeleteShadeId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [shadesData, setShadesData] = useState([]);

  const LIST_STATE_KEY = "shadeListState";
  const SEARCH_QUERY_KEY = "shadeSearchQuery";


  const getShadeNumberData = useSelector((state) => state?.shade?.shade);
  const isFiltered = useSelector((state) => state.shade.isFiltered);
  // Get Shades data
  useEffect(() => {
    setLoading(true);

    const savedQuery = sessionStorage.getItem(SEARCH_QUERY_KEY);

    if (savedQuery && isFiltered) {
      const queryPayload = {
        ...JSON.parse(savedQuery),
        page: currentPage,
        size: 30,
      };

      dispatch(getShadeNumberList(queryPayload))
        .then((res) => {
          setShadesData(res.payload?.data?.shades || []);
          const count = res.payload?.data?.Total || 0;
          setRecordCount(count);
        })
        .finally(() => setLoading(false));
    } else {
      dispatch(getShadeNumberList({ page: currentPage, size: 30 }))
        .then((res) => {
          setShadesData(res.payload?.data?.shades || []);
          const count = res.payload?.data?.Total || 0;
          setRecordCount(count);
        })
        .finally(() => setLoading(false));
    }
  }, [currentPage, dispatch, isFiltered]);

  // Sync with Redux state
  useEffect(() => {
    if (getShadeNumberData && getShadeNumberData.length > 0) {
      setShadesData(getShadeNumberData);
      // setRecordCount(getShadeNumberData.length);
    }
  }, [getShadeNumberData]);

  // useEffect(() => {
  //   if (shadesData && shadesData.length > 0) {
  //     setRecordCount(shadesData.length);
  //   }
  // }, [shadesData]);

  // total companies count
  const fetchTotalCount = async () => {
    try {
      const response = await countShade();

      const count = response.data.count;
      setRecordCount(response.data.count);

      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Deal count:", error);
    }
  };

  // useEffect(() => {
  //   fetchTotalCount();
  // }, []);
  // Parse image URLs from shadeMedia - MATCHING FORM LOGIC
  // const parseImageUrls = (shadeMedia) => {
  //   if (!shadeMedia) return [];

  //   try {
  //     // Handle empty array case
  //     if (shadeMedia === "[]") return [];

  //     // If it's already an array, return it
  //     if (Array.isArray(shadeMedia)) {
  //       return shadeMedia.map(item => item.url || '').filter(url => url && url !== 'true');
  //     }

  //     // If it's a string, use the same logic as in the form
  //     if (typeof shadeMedia === 'string') {
  //       console.log("Original shadeMedia string:", shadeMedia);

  //       // Remove the [ and ] brackets
  //       let mediaString = shadeMedia
  //         .replace(/^\[/, '')
  //         .replace(/\]$/, '')
  //         .trim();

  //       if (!mediaString) return [];

  //       // Split by }, { to get individual items
  //       const itemStrings = mediaString.split('}, {');

  //       const urls = itemStrings.map(itemStr => {
  //         // Clean up each item string
  //         const cleanedStr = itemStr.replace(/[{}]/g, '').trim();

  //         // Extract URL using regex
  //         const urlMatch = cleanedStr.match(/url=([^,]+)/);
  //         if (urlMatch) {
  //           let url = urlMatch[1].trim();

  //           // Clean up the URL
  //           url = url.replace(/['"]/g, ''); // Remove any quotes
  //           url = url.replace(/,\s*$/, ''); // Remove trailing comma

  //           // URL encode spaces and special characters
  //           if (url.includes(' ')) {
  //             // Encode the entire URL
  //             url = encodeURI(url);
  //           }

  //           return url;
  //         }
  //         return null;
  //       }).filter(url => url && url.startsWith('http'));

  //       console.log("Parsed URLs:", urls);
  //       return urls;
  //     }

  //     return [];
  //   } catch (error) {
  //     console.error('Error parsing image URLs:', error);
  //     // Fallback: try to extract URLs with simple regex
  //     try {
  //       const urlRegex = /https?:\/\/[^\s,}]+/g;
  //       const urls = shadeMedia.match(urlRegex);
  //       return urls || [];
  //     } catch (e) {
  //       return [];
  //     }
  //   }
  // };

  // Simplified parseImageUrls function
  const parseImageUrls = (shadeMedia) => {
    if (!shadeMedia) return [];

    try {
      // If it's already an array (as shown in your response), return it
      if (Array.isArray(shadeMedia)) {
        // return shadeMedia.filter(url => url && url.startsWith('https'));
        return shadeMedia.filter(url => url && typeof url === 'string' && url.trim().startsWith('http'))
        
      }

      // If it's a string, try to parse it
      if (typeof shadeMedia === 'string') {
        // Check if it's already a JSON array string
        if (shadeMedia.startsWith('[') && shadeMedia.endsWith(']')) {
          try {
            const parsed = JSON.parse(shadeMedia);
            if (Array.isArray(parsed)) {
              // Handle both string URLs and object URLs
              return parsed.map(item => {
                if (typeof item === 'string') return item;
                if (item && typeof item === 'object' && item.url) return item.url;
                if (item && typeof item === 'object' && item.filePath) return item.filePath;
                return null;
              }).filter(url => url && url.startsWith('http'));
            }
          } catch (e) {
            console.error('JSON parse error:', e);
          }
        }

        // Fallback: Try to extract URLs using regex
        const urlRegex = /https?:\/\/[^\s,}\]]+/g;
        const urls = shadeMedia.match(urlRegex);
        return urls || [];
      }

      return [];
    } catch (error) {
      console.error('Error parsing image URLs:', error);
      return [];
    }
  };


  // Get first image URL from shadeMedia
  const getFirstImageUrl = (item) => {
    if (!item) return '';

    const images = parseImageUrls(item.shadeMedia);
    return images.length > 0 ? images[0] : '';
  };

  // Modal handlers
  const openTrash = () => setIsOpen(true);
  const closeTrash = () => {
    setIsOpen(false);
    setDeleteShadeId(null);
  };
  const openSearch = () => setIsSearchOpen(true);
  const closeSearch = () => setIsSearchOpen(false);

  // Row selection handlers
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    const updatedRows = isSelected
      ? selectedRows.filter((id) => id !== ROWID)
      : [...selectedRows, ROWID];

    setSelectedRows(updatedRows);
  };

  const handleSelectAllRows = () => {
    if (selectedRows.length === shadesData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(shadesData.map((item) => item.ROWID));
    }
  };

  // Delete functionality
  const handleDelete = async () => {
    setLoading(true);

    try {
      const idsToDelete = deleteShadeId
        ? [deleteShadeId]
        : selectedRows;
console.log("idsToDelete", idsToDelete);
      // Delete from API
      await Promise.all(idsToDelete.map(id => deleteShade(id)));

      // Update Redux store
      dispatch(deleteShadeAction(idsToDelete));

      // Update local state
      setShadesData(prevData =>
        prevData.filter(item => !idsToDelete.includes(item.ROWID))
      );

      // // Update counts
      setRecordCount(prev => prev - idsToDelete.length);
      setTotalCount(prev => prev - idsToDelete.length);
      // fetchTotalCount();

      // Reset selections
      setSelectedRows([]);
      setDeleteShadeId(null);

      // Show success message
      toast.success(
        idsToDelete.length === 1
          ? "Shade deleted successfully"
          : `${idsToDelete.length} shades deleted successfully`
      );

    } catch (error) {
      console.error("Error deleting shades:", error);
      toast.error("Failed to delete shade(s)");
    } finally {
      setLoading(false);
      closeTrash();
    }
  };


  const handleReset = () => {
    setLoading(true);

    dispatch(setFilteredStatus(false));
    sessionStorage.removeItem(SEARCH_QUERY_KEY);
    sessionStorage.removeItem(LIST_STATE_KEY);
        // fetchTotalCount();

    setCurrentPage(1);
    dispatch(getShadeNumberList({ page: 1, size: 30 }))
      .then((res) => {
        console.log("full API response:", res``);
        const data = res.payload?.data?.shades || [];
        setShadesData(data);
        const count = res.payload?.data?.Total || 0;
        setRecordCount(count);
      })
      .catch(() => {
        toast.error("Failed to reset list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Save current list state to sessionStorage before navigating away
  const saveListState = () => {
    try {
      const savedQuery = sessionStorage.getItem(SEARCH_QUERY_KEY);
      const parsedQuery = savedQuery ? JSON.parse(savedQuery) : null;
      const stateObj = {
        page: currentPage,
        isFiltered: isFiltered,
        [SEARCH_QUERY_KEY]: parsedQuery,
      };
      sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify(stateObj));
    } catch (err) {
      console.error("Failed to save shade list state", err);
    }
  };

  // Restore list state from sessionStorage on mount
  useEffect(() => {
    try {
      const saved = sessionStorage.getItem(LIST_STATE_KEY);
      if (saved) {
        const obj = JSON.parse(saved);
        if (obj?.page) setCurrentPage(obj.page);
        if (typeof obj?.isFiltered !== "undefined") {
          dispatch(setFilteredStatus(obj.isFiltered));
        }

        if (obj?.[SEARCH_QUERY_KEY]) {
          sessionStorage.setItem(SEARCH_QUERY_KEY, JSON.stringify(obj[SEARCH_QUERY_KEY]));

          try {
            const parsed = obj[SEARCH_QUERY_KEY] || {};
            const queryPayload = {
              ...parsed,
              page: obj.page || currentPage,
              size: 30,
            };

            setLoading(true);
            dispatch(getShadeNumberList(queryPayload))
                .then((res) => {
                  setShadesData(res.payload?.data?.shades || []);
                  const count = res.payload?.data?.Total || 0;
                  setRecordCount(count);
                })
              .catch((err) => {
                console.error("Failed to fetch shades with saved query", err);
                setShadesData([]);
              })
              .finally(() => setLoading(false));
          } catch (err) {
            console.error("Error using saved SEARCH_QUERY_KEY for shades", err);
          }
        }
      }
    } catch (err) {
      console.error("Failed to restore shade list state", err);
    }
  }, []);

  // Map your response data to table columns
  const getTableData = (item) => ({
    shadeNumber: item.shadeNo,
    category: item.shadeCategory,
    fabric: item.fabric,
    gsm: item.gsm,
    uvBlockage: item.uvBlockage,
    opennessFactor: item.opennessFactor,
    greenGuard: item.greenGuard,
    createdTime: item.CREATEDTIME,
    createdBy: item.CREATORID,
    shadeName: item.shadeName,
    description: item.description,
    imageUrl: getFirstImageUrl(item),
  });


  const [categoryOptions, setCategoryOptions] = useState([]);
  const categoryList = useSelector((state) => state.category.category);
  const [categoryData, setCategoryData] = useState([]);


  useEffect(() => {
    setLoading(true);
    dispatch(getCategoryList({ page: currentPage, size: 30, limit: 30 })).then((response) => {
      setCategoryData(response.payload?.data || []);

    })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching Deal data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);

  // Fetch category list for parent category dropdown
  useEffect(() => {
    dispatch(getCategoryList());
  }, [dispatch]);

  // Prepare category options for dropdown
  useEffect(() => {
    const options = categoryData.map(item => ({
      label: item.name,
      value: item.ROWID,
    }));

    setCategoryOptions(options);
  }, [categoryData]);


  const categoryName = (id) => {
    const itemData = categoryOptions.filter(
      (item) => item?.value === id
    );
    return itemData[0]?.label;
  };
const [imgErrors, setImgErrors] = useState({});
const handleImageError = (id) => {
  setImgErrors((prev) => ({
    ...prev,
    [id]: true,
  }));
};
  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" />
        </div>
      )}

      {/* Delete Modal */}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedRows.length > 0
              ? `You are about to delete ${selectedRows.length} shade(s). This action cannot be undone.`
              : "This action cannot be undone."}
          </ModalBody>
          <ModalFooter>
            <Button className="main-btn" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <div className="min-h-[85vh] h-[97vh] relative">
        {/* Header */}
        <div className="d-flex justify-content-between mb-1 px-2 items-center">
          <div>
            {selectedRows.length > 0 && (
              <button className="main-btn mx-2" onClick={openTrash}>
                <span className="inner-content">
                  Delete All ({selectedRows.length})
                </span>
              </button>
            )}
          </div>

          <div className="flex gap-2 items-center">
            <button
              className="main-btn"
              onClick={isFiltered ? handleReset : openSearch}
            >
              <span className="inner-content">
                {isFiltered ? (
                  <>
                    <ListRestart size="18px" />
                    <span className="ms-1">Show All</span>
                  </>
                ) : (
                  <>
                    <Search size="18px" />
                    <span className="ms-1">Search</span>
                  </>
                )}
              </span>
            </button>
            {/* <Link to="/admin/shade-form">
              <button className="d-flex justify-content-between align-items-center main-btn">
                <span className="inner-content">
                  <Plus size="18px" />
                  <span className="ms-1">Add Shades</span>
                </span>
              </button>
            </Link> */}
            <button
              onClick={() => canAdd("shade") ? (saveListState(), navigate("/admin/inventory/shade-form")) : ""}
              className="d-flex justify-content-between align-items-center main-btn"
            >
              <span className="inner-content">
                <Plus size="18px" />
                <span className="ms-1">Add Shades</span>
              </span>
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="flex-grow px-1">
          <TableContainer
            style={{
              height: "calc(97vh - 135px)",
              background: "#fff",
              border: "1px solid #e7e7e7",
              overflow: "auto",
            }}
          >
            <Table size="sm">
              <Thead position="sticky" top={0} bg="white" zIndex={10}>
                <Tr>
                  <Th>
                    <Checkbox
                      isChecked={
                        shadesData.length > 0 &&
                        selectedRows.length === shadesData.length
                      }
                      isDisabled={shadesData.length === 0}
                      onChange={handleSelectAllRows}
                    />
                  </Th>
                  <Th>Actions</Th>
                  <Th>Image</Th>
                  <Th>Shade Number</Th>
                  {/* <Th>Shade Name</Th> */}
                  <Th>Category</Th>
                  <Th>Fabric</Th>
                  <Th>GSM</Th>
                  <Th>UV Blockage</Th>
                  {/* <Th>Openness Factor</Th> */}
                  <Th>Green Guard</Th>
                  <Th>Created By</Th>
                  <Th>Modified By</Th>
                  <Th>Created Time</Th>
                   <Th> modified Time</Th>
                  {/* <Th>Created By</Th> */}
                </Tr>
              </Thead>

              <Tbody>
                {shadesData.length > 0 ? (
                  shadesData.map((item) => {
                    const tableData = getTableData(item);
                    const imageUrl = tableData.imageUrl;
                    return (
                      <Tr key={item.ROWID}>
                        <Td>
                          <Checkbox
                            isChecked={selectedRows.includes(item.ROWID)}
                            onChange={() => handleRowSelect(item.ROWID)}
                          />
                        </Td>

                        <Td>
                          <div className="flex gap-1">
                            {/* <Eye
                              size={16}
                              // onClick={() => navigate(`/admin/shade-detail/${item.ROWID}`)}
                              onClick={() => 
                               canViewAll("shade") ? navigate("/admin/shade-detail", {
                                  state: {
                                    id: item.ROWID,
                                  },
                                }) : ""
                              }
                              cursor="pointer"
                              title="View"
                            /> */}
                            {canViewAll("shade") && (
                              <Eye
                                size={16}
                                onClick={() => navigate("/admin/inventory/shade-detail", {
                                  state: {
                                    id: item.ROWID,
                                  },
                                })}
                                cursor="pointer"
                                title="View"
                              />
                            )}
                            {/* <SquarePen
                              size={16}
                              cursor="pointer"
                              // onClick={() => navigate(`/admin/shade-form-update/${item.ROWID}`)}
                              onClick={() => 
                               canEdit ("shade") ? navigate("/admin/shade-form-update", {
                                  state: {
                                    isUpdateMode: true,
                                    id: item.ROWID,
                                  },
                                }) : ""
                              }
                              title="Edit"
                            /> */}


                            {canEdit("shade") && (
                              <SquarePen
                                size={16}
                                cursor="pointer"
                                onClick={() => (saveListState(), navigate("/admin/inventory/shade-form-update", {
                                  state: {
                                    isUpdateMode: true,
                                    id: item.ROWID,
                                  },
                                }))}
                                title="Edit"
                              />
                            )}
                            {/* <Trash2
                              size={16}
                              cursor="pointer"
                              onClick={() =>
                                canViewAll("shade")? {
                                setDeleteShadeId(item.ROWID) : "";
                                openTrash();
                              }}
                              title="Delete"
                            /> */}
                            {/* <Trash2
  size={16}
  cursor="pointer"
  onClick={() => {
    if (canViewAll("shade")) {
      setDeleteShadeId(item.ROWID);
      openTrash();
    }
  }}
  title="Delete"
/> */}
                            {canDelete("shade") && (
                              <Trash2
                                size={16}
                                cursor="pointer"
                                onClick={() => {
                                  setDeleteShadeId(item.ROWID);
                                  openTrash();
                                }}
                                title="Delete"
                              />
                            )}

                          </div>
                        </Td>

                        <Td>
                          <div style={{ height: "40px", width: "40px" }}>
                            {imageUrl && !imgErrors[item.ROWID] ? (
                              <img
                                src={imageUrl}
                                alt={`Shade ${tableData.shadeNumber}`}
                                style={{
                                  height: "40px",
                                  width: "40px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                                onError={() => handleImageError(item.ROWID)}
                              />
                            ) : (
                              <div
                                style={{
                                  height: "40px",
                                  width: "40px",
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                }}
                              >
                                No Image
                              </div>
                            )}
                            {/* {imgError ? (
                              <div style={{
                                height: "40px",
                                width: "40px",
                                backgroundColor: "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                                fontSize: "10px",
                              }}>
                                No Image
                              </div>
                            ) : (
                              <img
                                src={imageUrl}
                                alt={`Shade ${tableData.shadeNumber}`}
                                style={{
                                  height: "40px",
                                  width: "40px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                                onError={() => setImgError(true)}
                              />
                            )} */}
                          </div>
                        </Td>

                        <Td>{tableData.shadeNumber}</Td>
                        {/* <Td>{tableData.shadeName || 'N/A'}</Td> */}
                        <Td>{categoryName(tableData.category) || "N/A"}</Td>
                        <Td>{tableData.fabric}</Td>
                        <Td>{tableData.gsm}</Td>
                        <Td>{tableData.uvBlockage}</Td>
                        {/* <Td>{tableData.opennessFactor}</Td> */}
                        <Td>{tableData.greenGuard}</Td>

<Td>{getFullName(item.createdBy)}</Td>
<Td>{getFullName(item.modifiedBy)}</Td>

                    

                    
<Td>{formatDateTime(item.CREATEDTIME)}</Td>
                    
<Td>{formatDateTime(item.MODIFIEDTIME)}</Td>                        {/* <Td>{tableData.createdBy}</Td> */}
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Td colSpan={15} style={{ textAlign: 'center', padding: '20px' }}>
                      No shades found
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>

        {/* Footer */}
        <div
          className="w-100 bg-white shadow-sm"
          style={{ position: "sticky", bottom: 0, zIndex: 20 }}
        >
          <div className="row mx-2 flex items-center">
            <div className='col-lg-3 col-md-6 col-12'>
              <p className="fw-semibold mb-0">Total Count: {recordCount}</p>
            </div>
            <div className='col-lg-6 col-md-6 col-12 flex justify-center'>
              {/* <Pagination 
                totalPages={Math.ceil(totalCount / 30)} 
                onPageChange={setCurrentPage} 
                currentPage={currentPage}
              /> */}

              <Pagination totalPages={Math.ceil((recordCount || 0) / 30) || 1} onPageChange={setCurrentPage} pageCount={currentPage} />

            </div>
            <div className='col-lg-3 col-md-6 col-12'></div>
          </div>
        </div>
      </div>

      <ShadeSearchDrawer closeDrawer={closeSearch} isSearchDrawerOpen={isSearchOpen} setRecordCount={setRecordCount}/>
    </>
  );
}

export default ShadesList;